<template>
  <transition name="el-fade-in-linear">
    <section class="rounded-OFF border p-3" :style="{
      background: '#ecf5ff'
      // background: '#409EFF'
      // backgroundImage: 'linear-gradient(to right, #409EFF, #ecf5ff)'
    }">
      <!-- <h2 class="mb-4">
      <span>4.</span>
      {{ title }}
      </h2>-->

      <div class="px-0 bg-white border rounded-OFF" :style="{}">
        <!-- Auto Objectives -->
        <el-row
          :class="['py-3 px-3', isLast(i, all_objectives) ? '' : 'border-bottom']"
          v-for="(value, key, i) in all_objectives"
          :key="key"
        >
          <el-col :span="12" class="text-left">
            <b>{{ key }}:</b>
          </el-col>
          <!-- <el-col :span="2">&nbsp;</el-col> -->
          <el-col :span="12" class>
            <span v-html="value"></span>
            <!-- i: {{i}} / l: {{Object.keys(all_objectives).length}} / {{isLast(i, all_objectives)}} -->
          </el-col>
        </el-row>

        <!-- Custom Objectives -->
        <el-row :class="['py-3 px-3 border-top bg-white']">
          <el-col :span="24" class>
            <b>Objective statement: </b><span v-html="objectives.custom"></span>
          </el-col>
        </el-row>
      </div>

      <!-- <div class="px-0 mt-0">
      <el-checkbox id="check-3" size="medium" v-model="checked" class="el-checkbox-large">
        <strong>Yes, I confirm these are my objectives.</strong>
      </el-checkbox>
      </div>-->
    </section>
  </transition>
</template>

<script>
/**
 * ----------------------------------
 * Conditioning Sign Off
 * ----------------------------------
 *
 * 4. Your Objectives Are (Section)
 *
 */
export default {
  components: {
  },
  props: {
    objectives: {
      type: Object,
      default: () => ({ show: true, auto: {}, custom: '' })
    }
  },
  data() {
    return {
      // title: 'Your Objectives Are',
      checked: false
    }
  },
  computed: {
    // custom_objectives_array() {
    //   const str = this.objectives.custom
    //   return typeof str === 'string' ? str.split('\r\n') : []
    // },
    all_objectives() {
      // return this.objectives.auto.concat(this.custom_objectives_array)
      // const custom = {}
      // this.custom_objectives_array.forEach((e, i) => {
      //   custom['Overall'] = e
      // })
      // console.warn(custom)
      // return Object.assign(this.objectives.auto, custom)

      // e.g. I agree to protect my credit score by limiting any additional loan applications
      // until my Broli finance expert has finalised the best rate and repayment.

      // return Object.assign(this.objectives.auto, {
      //   'Objective statement': this.objectives.custom
      // })

      return this.objectives.auto
    }
  },
  watch: {
  },
  mounted() {
  },
  updated() {
  },
  activated() {
  },
  methods: {
    isLast(index, array) {
      const length = typeof array === 'object' && !Array.isArray(array) ? Object.keys(array).length : array.length
      return (index + 1) === length
    }
  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';
</style>
